import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import map from "../../images/map/mongolia-map.png";
import Salbaruud from "../../api/salbaruud";
import Mcc from "../mcc/Mcc";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // анхны render дээр дуудах

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

var salbarSlideSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  autoplay: true,
  arrows: false,
  rows: 2,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
      },
    },
  ],
};

const Testimonial3 = () => {
  const { width } = useWindowSize();
  return (
    <section className="review pt-40 pb-40 position-relative overflow-hidden">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="sectionTitle mb-65">
              <Mcc justify="start" />
              {/* <span className="sectionTitle__small justify-content-start">
                <i className="fa-solid fa-heart btn__icon"></i>
                мсс
              </span> */}
              <h2 className="sectionTitle__big">
                Монгол орны өнцөг булан бүрт
              </h2>
            </div>
            <div className="reviewMap mb-50">
              <img src={map} alt="mongolsuvd Map" />
            </div>
          </div>

          <div className="col-lg-6" style={{ paddingTop: "40px" }}>
            <div className="row">
              {width && width >= 991 ? (
                // 991-с ИХ үед slider алга болно
                Salbaruud.map((Salbar, index) => (
                  <div className="col-6 col-md-4 col-lg-2" key={index}>
                    <div className="reviewblock reviewblock--style2">
                      <div className="reviewblock__content">
                        <div className="reviewblock__author">
                          <div className="reviewblock__authorImage">
                            <img src={Salbar.tImg} alt="mongolsuvd Reviewer" />
                          </div>
                          <h3 className="reviewblock__authorName">
                            {Salbar.Name}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                // 991-с БАГА үед slider гарж ирнэ
                <Slider {...salbarSlideSettings}>
                  {Salbaruud.map((Salbar, index) => (
                    <div key={index}>
                      <div className="reviewblock reviewblock--style2">
                        <div className="reviewblock__content">
                          <div className="reviewblock__author">
                            <div className="reviewblock__authorImage">
                              <img
                                src={Salbar.tImg}
                                alt="mongolsuvd Reviewer"
                              />
                            </div>
                            <h3 className="reviewblock__authorName">
                              {Salbar.Name}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial3;
